import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Button, Dialog, DialogContent, Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";
import CockpitServiceableReturnViewList from "./CockpitServiceableReturnViewList";
import { ViewList } from "@material-ui/icons";

const CockpitServiceableReturn = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);
  const [chartValue, setChartValue] = useState(0);
  const [open, setOpen] = useState(false);

  const resourceEndpoint = "pbhrequestorders/cockpit/serviceablereturn";

  const subArcs = [
    {
      limit: 1,
      color: "#5BE12C",
      showTick: true,
    },
    {
      limit: 2,
      color: "#FFC700",
      showTick: true,
    },
    {
      limit: 10,
      color: "#EA4228",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (!chartData.length) return null;
    const returnCount = chartData.filter((d: any) => d.isServiceableReturn).length;
    return {
      ...buildAiBaseParams(filterParams),
      serviceableReturnRate: chartValue.toFixed(2),
      totalCount: chartData.length.toString(),
      returnCount: returnCount.toString(),
    };
  }, [filterParams, chartValue, chartData]);
  useAiInsight("cockpitserviceablereturn", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.isServiceableReturn, 0);
        const avg = Number(((sum / data.length) * 100).toFixed(2));
        setChartData(data);
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Serviceable Return
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} maxValue={10} formatTextValue="%" />
      <Button fullWidth startIcon={<ViewList />} onClick={() => setOpen(true)} color="primary">
        View
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <CockpitServiceableReturnViewList
            filterParams={filterParams}
            resource={resourceEndpoint}
            basePath={resourceEndpoint}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CockpitServiceableReturn;
